import { Component, OnInit } from '@angular/core';
import { LoginService } from '../../../services/authentication/login.service';

@Component({
  selector: 'app-logiadmin',
  templateUrl: './logiadmin.component.html',
  styleUrls: ['./logiadmin.component.css']
})
export class LogiadminComponent implements OnInit {

  	menu:any;
  	permissions = [];

	constructor(public auth: LoginService) { }

	ngOnInit() {
		this.menu = [
			{name:'Rutas', desc:'Gestor de rutas', icon:'fas fa-route', url:'/routeslogistics', perm: 'LOGI-ADMIN-ROUTE_LIST'},
			{name:'Destinos', desc:'Mant Destinos', icon:'fas fa-map-marker-alt', url:'/destinationslogistics', perm: 'LOGI-ADMIN-DESTINATION_LIST'},
			{name:'Transportes', desc:'Mant transportes', icon:'fas fa-truck', url:'/vehicleslogistics', perm: 'LOGI-ADMIN-VEHICLE_LIST'},
			{name:'Conductores', desc:'Mant conductores', icon:'fas fa-user', url:'/driverslogistics', perm: 'LOGI-ADMIN-DRIVER_LIST'},
			{name:'Monitoreo', desc:'Monitoreo de rutas', icon:'fas fa-map-marked-alt', url:'/monitoringlogistics', perm: 'LOGI-ADMIN-MONITORING'},
      {name:'Reporte de Rutas', desc:'Reporte de Rutas', icon:'fas fa-clipboard-list', url:'/routesreport', perm: 'LOGI-ADMIN-ROUTES_REPORT'},
      {name:'KPIs', desc:'Indicadores varios', icon:'fas fa-chart-line', url:'/kpishome', perm: 'LOGI-ADMIN-KPI_HOME'}
		];

		this.auth.getPermissions().then(x => {
            this.permissions = x;
        });
	}

	hasPermission(str:string){
        if( this.permissions.indexOf(str) > -1 ){
            return true;
        }
        else{
            return false;
        }
    }

}
